import React, { FunctionComponent } from 'react';
import { Table } from 'semantic-ui-react';
import { UserTableProps } from '../../../interfaces/props/users/user-table-props';

export const UserTable: FunctionComponent<UserTableProps> = (props) => (
  <Table unstackable celled selectable sortable>
    {props.children}
  </Table>
);
